import { useFeatureGates } from '@office-start/feature-gates-service';
import { useIdentity } from '@office-start/identity-service';
import { LazyComponentErrorBoundary, } from '@office-start/office-home-app-shared';
import { LazyRecommendedSuspenseComponent, RecommendedComponentFallback, } from '@office-start/recommended-component';
import { IMMEDIATE_PRIORITY } from '@office-start/scheduler-service';
import React, { lazy, useMemo } from 'react';
var RecommendedLazy = lazy(function () {
    return import(
    /* webpackChunkName: "recommended" */ '@office-start/recommended-component');
});
export var Recommended = function () {
    var _a;
    var identity = (_a = useIdentity()) === null || _a === void 0 ? void 0 : _a.data;
    var featureGates = useFeatureGates().data;
    var loadingUiEnabled = useMemo(function () {
        var _a, _b, _c;
        return (_c = (_b = (_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result) === null || _a === void 0 ? void 0 : _a.loadingUiGates) === null || _b === void 0 ? void 0 : _b.loadingUiEnabled) !== null && _c !== void 0 ? _c : false;
    }, [featureGates]);
    var lazyFeatureProps = useMemo(function () {
        return {
            disabled: identity === undefined || identity.isMsa,
            schedulePriority: IMMEDIATE_PRIORITY,
            suspendUntilReady: loadingUiEnabled,
            fallback: loadingUiEnabled
                ? RecommendedComponentFallback
                : undefined,
        };
    }, [identity, loadingUiEnabled]);
    return (React.createElement(LazyComponentErrorBoundary, { componentName: "Recommended", lazyFeatureProps: lazyFeatureProps }, loadingUiEnabled ? (React.createElement(LazyRecommendedSuspenseComponent, { useFeedApi: true })) : (React.createElement(RecommendedLazy, { useFeedApi: true }))));
};
//# sourceMappingURL=Recommended.js.map